import { render, staticRenderFns } from "./radio-group.vue?vue&type=template&id=1e96fb38&scoped=true"
import script from "./radio-group.vue?vue&type=script&lang=js"
export * from "./radio-group.vue?vue&type=script&lang=js"
import style0 from "./radio-group.vue?vue&type=style&index=0&id=1e96fb38&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e96fb38",
  null
  
)

export default component.exports